import React from "react";
import { icons, images } from "../Data";

const ProductCard = ({
  longTitle,
  deal,
  img,
  price,
  discountPrice,
  rangeMessage,
  buttonText,
}) => {
  return (
    <div className="flex link flex-col justify-start gap-4">
      {deal && (
        <div className="text-sm w-fit font-semibold rounded px-1.5 py-0.5 bg-black text-white">
          Deal
        </div>
      )}
      <div className=" min-w-[200px] relative border">
        <span className="absolute bg-white text-xl link hover:scale-95 text-black p-2 rounded-full right-2 top-2">
          {icons.heart}
        </span>
        <object
          data={img}
          type="image/jpeg"
          className="w-full object-cover h-full"
        >
          <img
            src={images.fallbackimg}
            alt={longTitle}
            className="w-full object-cover h-full"
          />
        </object>
      </div>
      <div className="">
        <div className="flex items-center gap-1 text-lg">
          <span className="font-bold text-[#2A8703]">Now</span>
          <span className="font-bold text-[#2A8703]">{discountPrice}</span>
          <span className="text-sm line-through text-[#656565]">{price}</span>
        </div>
        <div className="text-sm">{rangeMessage}</div>
      </div>
      <div>
        <div className="text-sm line-clamp-2 leading-tight">{longTitle}</div>
      </div>
      <div>
        <div className="flex w-fit items-center gap-1 font-semibold  px-4 h-10 rounded-full border hover:border-2 link border-black">
          <span className="text-2xl mb-1">{buttonText === "add" && "+"}</span>
          <span>{buttonText}</span>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
